import React from "react";
import PropTypes from "prop-types";
import { TableCell, TableRow } from "@mui/material";
import { TextField } from "@totalsoft/rocket-ui";

const ScoringIndicatorListRowComponent = ({
  idx,
  indicator,
  periodList,
  disabled,
  onFinancialIndicatorValueChange
}) => {
  return (
    <TableRow>
      <TableCell>{indicator.name}</TableCell>
      {periodList.length > 0 &&
        periodList.map(period => (
          <TableCell key={period.documentScoringFinancialIndicatorPeriodDimensionId}>
            <TextField
              isNumeric
              disabled={disabled}
              fullWidth
              value={indicator.values[period.dimensionPeriodId]}
              error={indicator.isMandatory && indicator.values[period.dimensionPeriodId] === null ? true : false}
              onChange={value => onFinancialIndicatorValueChange(idx, period.dimensionPeriodId, value)}
            />
          </TableCell>
        ))}
    </TableRow>
  );
};

ScoringIndicatorListRowComponent.propTypes = {
  idx: PropTypes.number.isRequired,
  indicator: PropTypes.object.isRequired,
  periodList: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  onFinancialIndicatorValueChange: PropTypes.func.isRequired
};

export default ScoringIndicatorListRowComponent;
